import { createStore } from 'vuex'

import user from './modules/user'
import invite from './modules/invite';
import {getUniqueVirtualAll} from "@/api/yuzhen/uniqueVirtual";

export default createStore({
  state: {
    isMobile: null,
    alertShowInfo: { // 弹窗配置信息
      isShow: false, // 是否显示弹窗
      title: '', // 弹窗标题
      content: '', // 弹窗内容
      isChancelShow: false, // 是否显示取消按钮
      callback: null, // 点击确认按钮回调
      cancelCallback: null // 点击取消按钮回调
    },
    yellowPagesInfo:{}, // 与真黄页信息
    previewFlag: false, // 预览标记返回
    newUserTipShowFlag: true, // 登录信息展示弹窗
    uniqueVirtualAll: []
  },
  mutations: {
    updateIsMobile(state, val) {
      state.isMobile = val;
    },
    closeAlert(state) {
      // 关闭弹窗
      state.alertShowInfo.isShow = false;
      state.alertShowInfo.title = '';
      state.alertShowInfo.content = '';
      state.alertShowInfo.content = '';
      state.alertShowInfo.isChancelShow = false;
      state.alertShowInfo.successCallback = null;
    },
    updateAlertInfo(state, val) {
      state.alertShowInfo = {
        ...val
      };
    },
    updateYellowPagesInfo(state, val) {
      state.yellowPagesInfo = val;
    },
  },
  actions: {
    asyncUpdateIsMobile(store, val) {
      store.commit('updateIsMobile', val)
    },
    asyncUpdateAlertInfo(store, val) {
      store.commit("updateAlertInfo", val)
    }
  },
  getters: {
    getIsMobile: state => {
      return state.isMobile;
    },
    getAlertShow: state => {
      return state.isAlertShow;
    }
  },
  modules: {
    user,
    invite
  }
})
